define('shared/initializer/form/adapters/mixins/Loginable',[
    '$',
    'shared/lib/RSVP'
], function (
    $,
    RSVP
) {
    'use strict';

    var KEY_REDIRECT = 'AutoLoginRedirect';
    var KEY_RESULT = 'Result';
    var KEY_SUCCESS = 'Success';

    function Ctor() { }

    Ctor.prototype.doSubmit = function( data ) {

        return new RSVP.Promise(function(resolve, reject){
            if ( data == null || data[KEY_SUCCESS] !== true ) {
                var err = new Error('Failed to login, no login path is found from remote server');
                err.fatal = false;
                reject(err);
            }
            else if (  data[KEY_RESULT] != null && data[KEY_RESULT][KEY_REDIRECT] != null ) {
                // ajax post to that url to log user in
                $.ajax({
                    url: data[KEY_RESULT][KEY_REDIRECT],
                    type: 'GET',
                    dataType: 'html'
                })
                .then( function(){
                    resolve( data );
                }, function(reason){
                    var err = reason || new Error(
                        'Failed to reach login server,' + 
                        ' please try login manually or refresh to submit again'
                    );
                    reject(err);
                } );
            }
            else {
                resolve( data );
            }
        
        });

    };

    return Ctor;
});
